import { c as _c } from "react/compiler-runtime";
import { createContext, useMemo, type ReactNode } from 'react';
import { Standard88Layout, type KeyboardLayoutRequirements, type KeyboardRequirements } from '@/lib/piano/keyboard';
import { KeyboardFactory } from '@/lib/piano/keyboard/keyboard-factory';
import { usePianoProfileState } from '@/hooks/store/use-piano-profile-store';
export interface KeyboardContextValue {
  keyboard: KeyboardRequirements;
  layout: KeyboardLayoutRequirements;
}
export const KeyboardContext = createContext<KeyboardContextValue | undefined>(undefined);
interface KeyboardProviderProps {
  children: ReactNode;
}
export const KeyboardProvider = t0 => {
  const $ = _c(11);
  const {
    children
  } = t0;
  const pianoProfile = usePianoProfileState();
  let t1;
  bb0: {
    if (pianoProfile.startNote) {
      let t2;
      if ($[0] !== pianoProfile.keyCount || $[1] !== pianoProfile.startNote) {
        t2 = {
          length: pianoProfile.keyCount,
          startNote: pianoProfile.startNote
        };
        $[0] = pianoProfile.keyCount;
        $[1] = pianoProfile.startNote;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t1 = t2;
      break bb0;
    }
    t1 = Standard88Layout;
  }
  const layout = t1;
  let t2;
  if ($[3] !== layout) {
    t2 = KeyboardFactory.fromLayout(layout);
    $[3] = layout;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const keyboard = t2;
  let t3;
  if ($[5] !== keyboard || $[6] !== layout) {
    t3 = {
      keyboard,
      layout
    };
    $[5] = keyboard;
    $[6] = layout;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const value = t3;
  let t4;
  if ($[8] !== children || $[9] !== value) {
    t4 = <KeyboardContext.Provider value={value}>{children}</KeyboardContext.Provider>;
    $[8] = children;
    $[9] = value;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};